import { render, staticRenderFns } from "./ApprovalStateCard.vue?vue&type=template&id=5274922d&"
import script from "./ApprovalStateCard.vue?vue&type=script&lang=ts&"
export * from "./ApprovalStateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports